export class ChangeLocation {
    constructor(options = {}) {

        this.tm = null;
        this.tmMoveEnd = null;
        this.stateAnimation = null;
        this.tmAnimation = null;

        this.defaultCoordinate = options.defaultCoordinate;

        this.co = [];

        this.storeList = options.storeList;

        this.ajaxUrl = options.ajaxUrl;

        this.deliveryType = options.deliveryType ? options.deliveryType : null;

        this.deliveryPoint = options.deliveryPoint ? options.deliveryPoint : null;

        this.pickupPoint = options.pickupPoint ? options.pickupPoint : null;

        this.deliveryStoreList = [];

        this.mapId = options.containerId + '-map';
        this.useMap = false;

        this.mapActionEnd = true;

        this.steps = [
            document.getElementById(options.containerId + '-step1'),
            document.getElementById(options.containerId + '-step2')
        ];

        this.obContainer = document.getElementById(options.containerId);

        this.obInputLocation = document.getElementById(options.containerId + '-input-location');
        this.obSuggestions = document.getElementById(options.containerId + '-suggestions');
        this.obSuggestionsLoading = document.getElementById(options.containerId + '-suggestions-loading');

        this.obErrorBlockInputLocation = document.getElementById(options.containerId + '-error-block-input-location');
        this.obBlockDeliveryType = document.getElementById(options.containerId + '-delivery-type');

        this.obFormDelivery = document.getElementById(options.containerId + '-form-delivery');
        this.obFormPickup = document.getElementById(options.containerId + '-form-pickup');

        this.obMapMarker = document.getElementById(options.containerId + '-map-marker');
        this.obMapShadow = document.getElementById(options.containerId + '-map-shadow');

        this.obConDeliveryType = document.getElementById(options.containerId + '-container-delivery-type');

        this.obBtnSubmitLoading = document.getElementById(options.containerId + '-btn-submit-loading');
        this.obBtnSubmit = document.getElementById(options.containerId + '-btn-submit');
        this.obBtnSubmitText = document.getElementById(options.containerId + '-btn-submit-text');

        this.obBtnSubmitPickupLoading = document.getElementById(options.containerId + '-btn-submit-pickup-loading');
        this.obBtnSubmitPickup = document.getElementById(options.containerId + '-btn-submit-pickup');
        this.obBtnSubmitPickupText = document.getElementById(options.containerId + '-btn-submit-pickup-text');

        this.obMainLoader = document.getElementById(options.containerId + '-main-loader');

        this.mapContainer = document.getElementById(options.containerId + '-map');

        this.map = null;
        this.point = null;

        //PICKUP
        this.mapPickupId = options.containerId + '-map-pickup';
        this.mapPickup = null;

        this.mapPickupContainer = document.getElementById(options.containerId + '-map-pickup');

        this.displayPvz = document.getElementById(options.containerId + '-input-pvz');
        this.obBtnPvzSubmit = document.getElementById(options.containerId + '-btn-submit-pvz');


        this.popup = document.getElementById(options.containerId + '-open-popup');
        this.popupClose = document.getElementById(options.containerId + '-close-popup');
        this.drawStoreList = document.getElementById(options.containerId + '-draw-store-list');
        this.inputSearch = document.getElementById(options.containerId + '-input-search');
        this.searchWordList = document.getElementById(options.containerId + '-search-word-list');


        this.initEvents();

        this.obBtnSubmit.setAttribute('disabled', 'disabled');
    }

    initEvents() {

        this.obFormDelivery.style.display = 'none';
        this.obFormPickup.style.display = 'none';

        //добавил
        this.mapContainer.style.display = 'none';
        this.mapPickupContainer.style.display = 'none';

        if (this.obContainer.querySelector("[type='radio'][name='type']:checked").value == 'pickup') {
            this.obFormPickup.style.display = 'flex';
            this.mapPickupContainer.style.display = 'flex';
        } else {
            this.obFormDelivery.style.display = 'flex';
            this.mapContainer.style.display = 'flex';
        }

        this.obContainer.querySelectorAll("[type='radio'][name='type']").forEach(el => {
            el.addEventListener('change', (e) => {



                this.obFormDelivery.style.display = 'none';
                this.obFormPickup.style.display = 'none';
                //добавил
                this.mapContainer.style.display = 'none';
                this.mapPickupContainer.style.display = 'none';


                if (e.target.value == 'pickup') {
                    this.obFormPickup.style.display = 'flex';
                    this.mapPickupContainer.style.display = 'flex';
                } else {
                    this.obFormDelivery.style.display = 'flex';
                    this.mapContainer.style.display = 'flex';

                }
            })
        });

        if (this.obInputLocation) {
            this.obInputLocation.addEventListener('input', this.eventInputLocation.bind(this));
            this.obInputLocation.addEventListener('focus', () => {
                this.obSuggestions.style.display = 'block';
            });
            this.obInputLocation.addEventListener('focusout', () => {
                setTimeout(() => {
                    this.hideSuggestions();
                }, 100);
                this.checkAvailableBtnSubmit();
            });
        }

        if (this.obFormDelivery) {
            this.obFormDelivery.addEventListener('submit', (e) => {
                e.preventDefault();

                if (!this.checkAvailableBtnSubmit())
                    return;

                this.obBtnSubmitLoading.style.display = 'block';
                this.obBtnSubmit.setAttribute('disabled', 'disabled');
                this.obBtnSubmitText.style.display = 'none';

                let formData = new FormData(e.target);

                let data = {
                    type: 'delivery',
                    deliveryPoint: {
                        address: this.deliveryPoint.address,
                        house: this.deliveryPoint.house,
                        coordinate: {
                            lon: this.deliveryPoint.coordinate.lon,
                            lat: this.deliveryPoint.coordinate.lat
                        }
                    },
                    deliverySubType: formData.get('storeType')
                };

                var options = {
                    method: "POST",
                    body: JSON.stringify(data)
                }

                fetch(this.ajaxUrl + '?action=save', options)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status) {
                            console.log(formData.get('storeType'));
                            (dataLayer = window.dataLayer || []).push({
                                'eventCategory': 'interaction',
                                'eventAction': 'addDeliveryMethod',
                                'eventLabel': formData.get('storeType'), // Передавать выбранный способ доставки
                                'event': 'GA4Event'
                            });
                            window.location.reload();
                        }
                    })
            });
        }

        if (this.obFormPickup) {
            this.obFormPickup.addEventListener('submit', (e) => {
                e.preventDefault();

                this.obBtnSubmitPickupLoading.style.display = 'block';
                this.obBtnSubmitPickup.setAttribute('disabled', 'disabled');
                this.obBtnSubmitPickupText.style.display = 'none';


                let formData = new FormData(e.target);

                let data = {
                    type: 'pickup',
                    pickupPoint: this.pickupPoint
                };

                var options = {
                    method: "POST",
                    body: JSON.stringify(data)
                }

                fetch(this.ajaxUrl + '?action=save', options)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status) {
                            window.location.reload();
                        }
                    })
            });
        }

        if (ymaps) {
            ymaps.ready(() => {

                let initCoordinate = this.defaultCoordinate;

                let isInitPickup = false;

                if (this.deliveryPoint) {
                    initCoordinate = [this.deliveryPoint.coordinate.lon, this.deliveryPoint.coordinate.lat];

                    this.obInputLocation.value = this.deliveryPoint.address;

                    this.getStores(this.deliveryPoint.coordinate.lon, this.deliveryPoint.coordinate.lat).then((result) => {
                        this.deliveryStoreList = result;
                        this.drawDeliveryBlock();
                    });
                } else if (navigator) {
                    navigator.geolocation.getCurrentPosition(({coords}) => {

                        this.getLocationByCoordinate([coords.longitude, coords.latitude]);

                        if (!this.isInitPickup)
                            this.setCenterMapPickup([coords.longitude, coords.latitude]);

                    }, ({message}) => {
                    }, {
                        enableHighAccuracy: false,
                        timeout: 4000,
                        maximumAge: 0
                    })
                }

                //Init delivery map
                this.initMap(initCoordinate);

                //Init pvz map
                this.initMapPickup(initCoordinate);

                if (this.pickupPoint) {
                    let store = this.storeList.find((store) => store['ID'] == this.pickupPoint.storeId);
                    if (store) {
                        this.changePVZ(store);
                        this.isInitPickup = true;
                    }
                }
            });
        }

        if (this.popup) {
            this.popup.addEventListener('click', () => {
                document.querySelector('.modal-choice-address__popup').classList.add('modal-choice-address__popup--open');
            })
        }

        if (this.popupClose) {
            this.popupClose.addEventListener('click', (e) => {
                document.querySelector('.modal-choice-address__popup--open').classList.remove('modal-choice-address__popup--open');
                this.inputSearch.value = '';
                document.querySelector('.modal-choice-address__popup-list').style.display = 'block';
                document.querySelector('.modal-choice-address__popup-list-search').style.display = 'none';
                document.querySelector('.modal-choice-address__popup-not-result').style.display = 'none';
            })
        }

        if (this.inputSearch) {
            let word = [];
            this.inputSearch.addEventListener('keyup', (e) => {
                word = this.searchWord(e.target.value, this.storeList);

                if (e.target.value == '') {
                    document.querySelector('.modal-choice-address__popup-list').style.display = 'block';
                    document.querySelector('.modal-choice-address__popup-list-search').style.display = 'none';
                } else {
                    document.querySelector('.modal-choice-address__popup-list').style.display = 'none';
                    document.querySelector('.modal-choice-address__popup-list-search').style.display = 'block';
                }
                if (word.length == 0 && e.target.value != '') {
                    document.querySelector('.modal-choice-address__popup-not-result').style.display = 'block';
                    document.querySelector('.modal-choice-address__popup-list-search').style.display = 'none';
                } else {
                    document.querySelector('.modal-choice-address__popup-not-result').style.display = 'none';
                }
                this.drawList(word, this.searchWordList)
            })
        }

    }

    degreesToRadians(degrees) {
        return degrees * Math.PI / 180;
    }

    distanceInKmBetweenEarthCoordinates(one, two) {
        let earthRadiusKm = 6371;
        let lat1 = one[0];
        let lon1 = one[1];
        let lat2 = two[0];
        let lon2 = two[1];
        let dLat = this.degreesToRadians(lat2 - lat1);
        let dLon = this.degreesToRadians(lon2 - lon1);

        lat1 = this.degreesToRadians(lat1);
        lat2 = this.degreesToRadians(lat2);

        let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return parseInt((earthRadiusKm * c) * 100) / 100
    }

    searchWord(word, storeList) {
        return storeList.filter(item => {
            const regex = new RegExp(word, 'gi');
            return item.ADDRESS.match(regex);
        })
    }

    drawList(array, element) {

		element.innerHTML = '';

		array.forEach( item => {

            if(item.COORDINATE) {


                const li = document.createElement("li");
                li.classList.add('modal-choice-address__popup-item');
                li.addEventListener('click', ev => {
                    this.changePVZ(item);
                    let coordinates = this.mapPickup.geoObjects.get(0).getGeoObjects();
                    for (let i = 0; i < coordinates.length; i++) {
                        if (coordinates[i].properties.get('store')['ID'] == item['ID']) {
                            coordinates[i].options.set('iconImageHref', '/local/components/asteq/change.location/templates/.default/map_baloon_active.svg');
                        } else {
                            coordinates[i].options.set('iconImageHref', '/local/components/asteq/change.location/templates/.default/map_baloon.svg');
                        }

                    }
                    document.querySelector('.modal-choice-address__popup--open').classList.remove('modal-choice-address__popup--open');
                    this.inputSearch.value = '';
                    document.querySelector('.modal-choice-address__popup-list').style.display = 'block';
                    document.querySelector('.modal-choice-address__popup-list-search').style.display = 'none';
                    document.querySelector('.modal-choice-address__popup-not-result').style.display = 'none';
                });
                li.innerHTML = `<span class="modal-choice-address__popup-btn">
		                                    <div class="modal-choice-address__popup-btn-body">
		                                        <div class="modal-choice-address__popup-btn-address">${item.ADDRESS}</div>
		                                        <div class="modal-choice-address__popup-btn-time"></div>
		                                    </div>
		                                    <div class="modal-choice-address__popup-btn-distance">${item.DISTANCE} км</div>
		                                </span>`;
                element.append(li);
            }
        });
    }

    eventInputLocation(event) {

        this.deliveryPoint = null;

        const q = event.target.value;

        if (this.tm)
            clearTimeout(this.tm);

        this.tm = setTimeout(() => {
            this.obSuggestionsLoading.style.display = 'block';
            this.getSuggestionsAddresses(q).then(result => this.showSuggestions(result));
        }, 600)
    }

    getSuggestionsAddresses(q) {

        if(ymaps && false){
            return ymaps.geocode(q,{results: 6, kind:'house'})
                .then((resp)=>{

                    let ret = [];

                    let objects = resp.geoObjects.toArray();

                    for(let object of  objects){
                        let data = object.properties.get('metaDataProperty').GeocoderMetaData;
                        let point = object.geometry.getCoordinates();
                        let house = data?.Address?.Components?.find(item=>item.kind == 'house');
                        ret.push({
                            "address": data.text,
                            "house": house?house.name:'',
                            "coordinate": {
                                "lon": point[0],
                                "lat": point[1]
                            }
                        });
                    }
                    return ret;
                })
                .catch((err)=>{
                    console.warn(err.message);
                })
        }

        // return false;

        return fetch(this.ajaxUrl + `?action=addresses&q=${q}`).then(response => response.json());
    }

    showSuggestions(data) {

        this.obSuggestions.innerHTML = '';

        for (let item of data) {
            let div = document.createElement('div');
            div.addEventListener('mousedown', this.changeSuggestionLocation.bind(this, item));
            div.classList.add('modal-choice-address__input-list-element');
            div.innerText = item['address'];
            this.obSuggestions.append(div);
        }

        this.obSuggestionsLoading.style.display = 'none';
    }

    hideSuggestions() {
        this.obSuggestions.style.display = 'none';
    }

    changeSuggestionLocation(item) {

        this.obMainLoader.style.display = 'flex';
        this.changeLocation(item);

        // //Запрос в яндекс на получение более точных координат. Dadata не всегда отдает правильные координаты
        // let address = item.address;
        // fetch(this.ajaxUrl + `?action=location&address=${address}`).then(response => response.json()).then((result => {
        //     if (result.address) {
        //         this.changeLocation(result);
        //     } else {
        //         this.changeLocation(item);
        //     }
        // })).catch(() => {
        //     this.changeLocation(item);
        // });

    }

    changeLocation(item) {
        if (item.address) {

            this.obMainLoader.style.display = 'flex';

            this.obInputLocation.value = item.address;
            this.hideSuggestions();

            if (this.map)
                this.map.setCenter([item.coordinate.lon, item.coordinate.lat]);

            this.setLocation(item);

            this.getStores(this.deliveryPoint.coordinate.lon, this.deliveryPoint.coordinate.lat).then((result) => {
                this.deliveryStoreList = result;
                this.drawDeliveryBlock();
                this.obMainLoader.style.display = 'none';
            });
        } else {
            this.deliveryPoint = null;
            this.obInputLocation.value = '';
            this.deliveryStoreList = [];
            this.drawDeliveryBlock('location');
        }
    }

    validationAddress(item) {
        this.obErrorBlockInputLocation.style.display = 'none';

        if (item && item.data && item.data.house) {
            return true;
        }

        this.obErrorBlockInputLocation.style.display = 'block';
        return false;
    }

    getStores(lon, lat) {
        return fetch(this.ajaxUrl + `?action=stores&lon=${lon}&lat=${lat}`).then(response => response.json());
    }

    initMap(coordinate) {

        let state = {
            center: coordinate,
            zoom: 16,
            controls: ['geolocationControl', 'zoomControl']
        };

        this.map = new ymaps.Map(this.mapId, state);

        const polygonOptions = {
            fillColor: '#1bad03',
            interactivityModel: 'default#transparent',
            strokeWidth: 2,
            fillOpacity: 0.2,
            strokeOpacity: 0.9,
            strokeColor: '#1bad03',
        }

        const expressPolygonOptions = {
            fillColor: '#1bad03',
            interactivityModel: 'default#transparent',
            strokeWidth: 2,
            fillOpacity: 0.0,
            strokeOpacity: 0.3,
            strokeColor: '#1bad03',
        }

        for (const store of this.storeList) {
            if (store['COORDINATES'] && store['COORDINATES'].length) {
                this.map.geoObjects.add(new ymaps.Polygon(
                    store['COORDINATES'],
                    {
                        // hintContent: storeId
                    }, store['TYPE'] == 'store' ? polygonOptions : polygonOptions));
            }

            if (store['EXPRESS_COORDINATES'] && store['EXPRESS_COORDINATES'].length) {
                this.map.geoObjects.add(new ymaps.Polygon(
                    store['EXPRESS_COORDINATES'],
                    {
                        // hintContent: storeId
                    }, store['TYPE'] == 'store' ? polygonOptions : polygonOptions));
            }
        }

        document.getElementById(this.mapId).addEventListener('mousedown', this.down.bind(this));
        document.getElementById(this.mapId).addEventListener('pointerdown', this.down.bind(this), false);

        document.getElementById(this.mapId).addEventListener('mouseup', this.up.bind(this));
        document.getElementById(this.mapId).addEventListener('pointerup', this.up.bind(this), false);


        this.map.events.add('actionbegin', (e) => {
            if (this.tmMoveEnd)
                clearTimeout(this.tmMoveEnd);
            this.co = this.map.getCenter();
            this.mapActionEnd = false;
        });

        this.map.events.add('actionend', (e) => {
            this.mapActionEnd = true;

            if (!this.mouseClick && this.useMap && (this.co[0] != this.map.getCenter()[0] || this.co[1] != this.map.getCenter()[1]))
                this.moveEnd();
        });
    }

    initMapPickup(coordinate) {

        let state = {
            center: coordinate,
            zoom: 12,
            controls: ['geolocationControl', 'zoomControl']
        };

        this.mapPickup = new ymaps.Map(this.mapPickupId, state);

        let points = [];

        for (const store of this.storeList) {
            if (store['COORDINATE'] != null && store['COORDINATE'].length) {

                let p = new ymaps.Placemark(
                    store['COORDINATE'], {
                        balloonContent: '',
                        iconCaption: '',
                        store: store
                    }, {
                        iconLayout: 'default#image',
                        iconImageHref: "/local/components/asteq/change.location/templates/.default/map_baloon.svg",
                        iconImageSize: [30, 44],
                        iconImageOffset: [-15, -44],
                        preset: 'islands#greenDotIconWithCaption'
                    })

                if (this.pickupPoint) {
                    if (store['ID'] == this.pickupPoint.storeId) {
                        p.options.set('iconImageHref', '/local/components/asteq/change.location/templates/.default/map_baloon_active.svg');
                    }
                }

                p.events.add('click', (e) => {
                    for (let i = 0; i < points.length; i++) {
                        points[i].options.set('iconImageHref', '/local/components/asteq/change.location/templates/.default/map_baloon.svg');
                    }
                    let target = e.get('target');
                    e.get('target').options.set('iconImageHref', '/local/components/asteq/change.location/templates/.default/map_baloon_active.svg');
                    let store = target.properties.get('store');
                    this.changePVZ(store);
                });

                points.push(p);
            }
        }

        var clusterer = new ymaps.Clusterer({
            gridSize: 64,
            groupByCoordinates: false,
            hasBalloon: false,
            hasHint: false,
            margin: 10,
            maxZoom: 10,
            minClusterSize: 2,
            showInAlphabeticalOrder: false,
            viewportMargin: 128,
            zoomMargin: 0,
            clusterDisableClickZoom: false,
            preset: 'islands#blackClusterIcons',
        });


        clusterer.add(points);

        for (const store of this.storeList) {
            if (store['COORDINATE'] == null) {
                store['DISTANCE'] = 0;
            } else {
                store['DISTANCE'] = this.distanceInKmBetweenEarthCoordinates(store['COORDINATE'], [38.971998, 45.04050]);
            }
        }

        this.storeList.sort((a, b) => a.DISTANCE - b.DISTANCE);

        this.mapPickup.geoObjects.add(clusterer);

        this.drawList(this.storeList, this.drawStoreList);
    }

    setCenterMapPickup(coordinate) {
        this.mapPickup.setCenter(coordinate);
    }

    changePVZ(store) {
    	this.setCenterMapPickup(store['COORDINATE']);
        this.obBtnSubmitPickup.removeAttribute('disabled');
        this.displayPvz.value = store['ADDRESS'];
        this.pickupPoint = {
            address: store['ADDRESS'],
            storeId: store['ID'],
            coordinate: {
                lon: store['COORDINATE'][0],
                lat: store['COORDINATE'][1],
            }
        }
    }

    down() {
        if (this.tmMoveEnd)
            clearTimeout(this.tmMoveEnd);
        this.useMap = true;
        this.mouseClick = true;

        if (this.map)
            this.co = this.map.getCenter();

        if (this.stateAnimation !== "slideIn") {
            this.stateAnimation = "slideIn";
            this.tmAnimation = this.animationSlideIn(this.obMapMarker, 1000);
        }
    }

    up() {
        this.useMap = true;
        this.mouseClick = false;

        if (this.map && this.mapActionEnd && this.co[0] != this.map.getCenter()[0] || this.co[1] != this.map.getCenter()[1])
            this.moveEnd();

        if (this.stateAnimation == "slideIn") {
            this.stateAnimation = undefined;
            clearInterval(this.tmAnimation);
            this.obMapMarker.style.transform = "translateY(6px)";
        }
    }

    moveEnd() {
        if (this.tmMoveEnd)
            clearTimeout(this.tmMoveEnd);

        this.tmMoveEnd = setTimeout(() => {
            this.useMap = false;
            if (this.map)
                this.getLocationByCoordinate(this.map.getCenter());
        }, 500)
    }

    animationSlideIn(object, interval) {
        let currentTime = 0;
        return setInterval(
            (function animation() {
                currentTime += interval;
                switch (currentTime % (interval * 2)) {
                    case 0:
                        object.style.transform = "translateY(0px)";
                        break;
                    case interval:
                        object.style.transform = "translateY(-6px)";
                        break;
                }
                return animation;
            })(),
            interval
        );
    }

    getLocationByCoordinate(coordinate) {

        if(ymaps){
            return ymaps.geocode(coordinate.join(','),{results: 1, kind:'house'})
                .then((resp)=>{

                    let ret = [];

                    let objects = resp.geoObjects.toArray();

                    for(let object of  objects){
                        let data = object.properties.get('metaDataProperty').GeocoderMetaData;
                        let point = object.geometry.getCoordinates();
                        let house = data?.Address?.Components?.find(item=>item.kind == 'house');
                        ret.push({
                            "address": data.text,
                            "house": house?house.name:'',
                            "coordinate": {
                                "lon": point[0],
                                "lat": point[1]
                            }
                        });
                    }
                    if(ret[0])
                        this.changeLocation(ret[0]);

                    return ret;
                })
                .catch((err)=>{
                    console.warn(err.message);
                })
        }

        // const lon = coordinate[0];
        // const lat = coordinate[1];
        // return fetch(this.ajaxUrl + `?action=location&lon=${lon}&lat=${lat}`).then(response => response.json()).then((result => {
        //
        //     this.changeLocation(result);
        // }));
    }

    setLocation(location) {
        this.deliveryPoint = location;
        this.obInputLocation.value = location.address;
    }

    changeStep(step) {
        if (this.steps[step - 1]) {
            for (const conStep of this.steps) {
                conStep.style.display = 'none';
            }
            this.steps[step - 1].style.display = 'block';
        }
    }

    drawDeliveryBlock(action = '') {

        this.obBlockDeliveryType.innerHTML = '';

        if (this.deliveryStoreList.length > 0)
            this.obConDeliveryType.style.display = 'block';
        else
            this.obConDeliveryType.style.display = 'none';

        let selected = false;

        if (this.deliveryStoreList.length > 0 && this.deliveryStoreList.filter(el => el['SELECTED']).length == 0) {
            this.deliveryStoreList[0]['SELECTED'] = true;
        }

        for (const item of this.deliveryStoreList) {
            const label = document.createElement("label");
            label.classList.add('modal-choice-address__delivery-way-checkbox-label');

            const input = document.createElement("input");
            input.classList.add('modal-choice-address__delivery-way-checkbox');
            input.type = 'radio';
            input.name = 'storeType';
            input.value = item['TYPE'];
            input.checked = item['SELECTED'];

            if (item['SELECTED'])
                selected = true;

            const div = document.createElement("div");
            div.classList.add('modal-choice-address__delivery-way');
            const name = item['NAME'];
            const count = item['COUNT'] + ' товаров';
            const descr = item['DESCR'];
            div.innerHTML = `<div class="modal-choice-address__delivery-way__inner">
                                <div class="modal-choice-address__delivery-way-header">
                                    <div class="modal-choice-address__delivery-way-container">
                                        <div>
                                            <div class="modal-choice-address__delivery-way-header__name">${name}</div>
                                            <div class="modal-choice-address__delivery-way-header__text">Как можно раньше</div>
                                        </div>
                                        <div class="modal-choice-address__delivery-way-header__count-shops"><div class="modal-choice-address__delivery-way-header__count-shops-container">${count}</div></div>
                                    </div>
                                  
                                </div>
                            </div>`;

            label.append(input);
            label.append(div);
            this.obBlockDeliveryType.append(label);
        }

        if (this.map)
            this.map.container.fitToViewport();

        this.checkAvailableBtnSubmit(action);
    }

    checkAvailableBtnSubmit(action = '') {

        this.obBtnSubmit.setAttribute('disabled', 'disabled');

        this.obErrorBlockInputLocation.style.display = 'none';

        if (action == 'location' && this.deliveryStoreList.length == 0) {
            this.obErrorBlockInputLocation.innerText = 'К сожалению, сюда не доставляем';
            this.obErrorBlockInputLocation.style.display = 'block';
            return false;
        }

        if (this.deliveryPoint && this.deliveryPoint.house) {
        } else {
            this.obErrorBlockInputLocation.innerText = 'Необходимо указать адрес с точностью до № дома';
            this.obErrorBlockInputLocation.style.display = 'block';
            return false;
        }

        if (this.deliveryStoreList.length == 0) {
            this.obErrorBlockInputLocation.innerText = 'К сожалению, сюда не доставляем'; //'Невозможно осуществить доставку по адресу';
            this.obErrorBlockInputLocation.style.display = 'block';
            return false;
        }

        this.obBtnSubmit.removeAttribute('disabled');

        return true;
    }

    getDefaultCoordinate() {
        return fetch(this.ajaxUrl + `?action=coordinate`)
            .then(response => response.json())
            .then((result) => {
                if (result)
                    return result;
                return {lon: 38.976260964154555, lat: 45.04001781328103};
            });
    }
}
